import _ from "lodash";
import { ReactElement } from "react";

import { palette } from "~frontend/theme";
import { formatDollars } from "~frontend/util/formatDollars";

import { Chart } from "./Chart";
import { ChartContainer } from "./ChartContainer";
import { Month } from "./monthlyBuckets";

type Data = {
  month: Month;
  amountRaisedOnetimeDollars?: number;
  amountRaisedRecurringDollars?: number;
}[];

export function MonthlyDonationsByTypeChart({
  data,
}: {
  data: Data | null;
}): ReactElement {
  return (
    <ChartContainer
      title="Monthly Donations by Type"
      loading={!data}
      downloadableRows={data?.map(r => ({
        month: r.month.toString(),
        amountRaisedOnetimeDollars: (r.amountRaisedOnetimeDollars ?? 0).toFixed(
          2
        ),
        amountRaisedRecurringDollars: (
          r.amountRaisedRecurringDollars ?? 0
        ).toFixed(2),
      }))}
      downloadFileName="monthlyDonationsByType.csv"
      empty={data?.length === 0}
    >
      <Chart
        data={data ?? []}
        series={[
          {
            type: "bar",
            yAxisId: "monthlyDonations",
            label: "Recurring",
            color: palette.darkGreen,
            getValue: d => d.amountRaisedRecurringDollars ?? null,
          },
          {
            type: "bar",
            yAxisId: "monthlyDonations",
            label: "One Time",
            color: palette.blue,
            getValue: d => d.amountRaisedOnetimeDollars ?? null,
          },
        ]}
        getXAxisValue={d => d.month.toString()}
        xAxisLabel="Campaign Start Month"
        xAxisTicks={4}
        yAxes={{
          monthlyDonations: {
            formatValue: value => formatDollars(value, 2)!,
            formatTick: value => formatDollars(value, 0)!,
            label: "Monthly Donations",
            width: 80,
          },
        }}
        height={280}
      />
    </ChartContainer>
  );
}
